import DefaultValidation from "@/services/validations/DefaultValidation";
import { isNull } from "@/functions/Util";

export default class DespesaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }
    
    validate(model, motivoDespesa, refs) {
        let validated = true;

        let valormaximo = (motivoDespesa.valormaximo == 0)
            ? 99999999999 : motivoDespesa.valormaximo

        Object.entries(model).forEach(([key, value]) => {
            if(value!=null && typeof value == "string") model[key] = value.trim();
        });
        
        if (model.iddespesa_motivo == null) {
            refs.motivoDespesa.focusedOut = true;
            validated = false;
        }
        
        if (isNull(model.valordespesa) || model.valordespesa == 0 || model.valordespesa > valormaximo) {
            refs.valordespesa.focusedOut = true;
            validated = false;
        }

        if (motivoDespesa.odometroobriga == 1 && isNull(model.odometro)) {
            refs.odometro.focusedOut = true;
            validated = false;
        }

        if (motivoDespesa.distanciaobriga == 1 && isNull(model.distanciapercorrida)){
            refs.distanciapercorrida.focusedOut = true;
            validated = false;
        }

        if (motivoDespesa.placaobriga == 1 && isNull(model.placaveiculo)){
            refs.placaveiculo.focusedOut = true;
            validated = false;
        }

        if (motivoDespesa.estabelecimentoobriga == 1 && isNull(model.estabelecimento)){
            refs.estabelecimento.focusedOut = true;
            validated = false;
        }

        if (motivoDespesa.centrocustoobriga == 1 && isNull(model.idfin_centro_custo)) {
            refs.centro_custo.focusedOut = true;
            validated = false;
        }

        if (motivoDespesa.forma_pagamentoobriga == 1 && isNull(model.iddes_formapagto)) {
            refs.forma_pagamento.focusedOut = true;
            validated = false;
        }

        if (motivoDespesa.solicitar_reembolsoobriga == 1 && isNull(model.solicitar_reembolso)) {
            refs.solicitar_reembolso.focusedOut = true;
            validated = false;
        }

        if (motivoDespesa.obsobriga == 1 && isNull(model.observacaogeral)) {
            refs.observacaogeral.focusedOut = true;
            validated = false;
        }

        if (
            motivoDespesa.fotoobriga == 1 && 
            model.acertoDespesaItemFotoListActual.length + model.acertoDespesaItemFotoListNew.length < model.qtdeminimafoto
        ){
            refs.foto.focusedOut = true;
            validated = false;
        }

        return validated;
    }

}